import { Button } from '@sam/components';

import { IconComponent, IconType } from '../icons/IconComponent';

interface SaveButtonProps {
  handleSubmit: (redirect: boolean) => void;
  buttonRef?: React.RefObject<HTMLButtonElement>;
  disabled?: boolean;
}
export const SaveButtons: React.FC<SaveButtonProps> = ({
  handleSubmit,
  buttonRef,
  disabled = false,
}) => {
  return (
    <>
      <button type="submit" disabled={disabled} value={''} ref={buttonRef} className="hidden" />
      <Button
        value={
          <div className="save-and-navigate__wrapper">
            <IconComponent type={IconType.ARROW_LEFT} className="save-and-navigate__arrow" />
            <IconComponent type={IconType.SAVE} className="save-and-navigate__save" />
          </div>
        }
        type="button"
        disabled={disabled}
        onClick={() => handleSubmit(true)}
      />
      <Button
        value={<IconComponent type={IconType.SAVE} className="save-icon" />}
        type="button"
        disabled={disabled}
        onClick={() => handleSubmit(false)}
      />
    </>
  );
};
